export const COLLECTION_LIST_QUERY_KEY = 'collection-list';
export const COLLECTION_QUERY_KEY = 'collection-search';
export const COLLECTION_MUTATE_KEY = 'collection-search-set';
export const COLLECTION_ITEM_QUERY_KEY = 'collection-search-items';
export const COLLECTION_ITEM_DELETE_KEY = 'collection-search-items-delete';
export const COLLECTION_ITEM_MUTATE_KEY = 'collection-search-items-set';
export const COLLECTION_CREATE_MUTATE_KEY = 'collection-create';
export const COLLECTION_PAGINATED_ITEMS_KEY =
  'collection-search-items-paginated';
